import { blocks } from '@/endpoint.flexigo';
import Repository from './repository';

const client = new Repository();

export default {
  /**
   * Get all active blocks
   * @returns {Promise<Array<{id: number, blockCode: string, displayName: string, color: string, isActive: boolean}>>}
   */
  async getBlocks() {
    const r = await client.get(blocks.list);
    return r;
  },

  /**
   * Search blocks by query
   * @param {string} query - Search term for block code or display name
   * @returns {Promise<Array<{id: number, blockCode: string, displayName: string, color: string, isActive: boolean}>>}
   */
  async searchBlocks(query) {
    const r = await client.get(blocks.search, { query });
    return r;
  },

  /**
   * Create a new block
   * @param {object} payload - Block request
   * @param {string} payload.blockCode - Required, unique per company
   * @param {string} payload.displayName - Optional, defaults to blockCode
   * @param {string} payload.color - Optional, hex color code
   * @returns {Promise<{id: number, blockCode: string, displayName: string, color: string, isActive: boolean}>}
   */
  async createBlock(payload) {
    const r = await client.post(blocks.create, payload);
    return r;
  },

  /**
   * Update an existing block
   * @param {object} payload - Block request with id
   * @param {number} payload.id - Required for update
   * @param {string} payload.blockCode - Required
   * @param {string} payload.displayName - Optional
   * @param {string} payload.color - Optional
   * @returns {Promise<{id: number, blockCode: string, displayName: string, color: string, isActive: boolean}>}
   */
  async updateBlock(payload) {
    const r = await client.post(blocks.update, payload);
    return r;
  },

  /**
   * Delete a block (soft delete)
   * @param {number} blockId - The block ID to delete
   * @returns {Promise<{result: string, data: any, error: any, ok: boolean}>}
   */
  async deleteBlock(blockId) {
    const url = blocks.delete.replace(':blockId', blockId);
    const r = await client.delete(url);
    return r;
  },

  /**
   * Check delete impact before deleting a block
   * @param {number} blockId - The block ID to check
   * @returns {Promise<{routeCount: number, relationCount: number, instanceCount: number}>}
   */
  async getBlockImpact(blockId) {
    const url = blocks.impact.replace(':blockId', blockId);
    const r = await client.get(url);
    return r;
  },

  /**
   * Assign block to specific routes (Block tab in Edit Assignments)
   * @param {object} payload - Assignment request
   * @param {number} payload.blockId - The block ID to assign
   * @param {Array<{id: number, direction: string}>} payload.routes - Routes to assign
   * @param {string} payload.startDate - Start date (YYYY-MM-DD)
   * @param {string} payload.endDate - End date (YYYY-MM-DD)
   * @param {boolean} payload.monday - Apply to Mondays
   * @param {boolean} payload.tuesday - Apply to Tuesdays
   * @param {boolean} payload.wednesday - Apply to Wednesdays
   * @param {boolean} payload.thursday - Apply to Thursdays
   * @param {boolean} payload.friday - Apply to Fridays
   * @param {boolean} payload.saturday - Apply to Saturdays
   * @param {boolean} payload.sunday - Apply to Sundays
   * @returns {Promise<{success: boolean, message: string, createdAssignmentIds: Array, conflicts: Array}>}
   */
  async assignBlockToRoutes(payload) {
    const r = await client.post(blocks.assignRoutes, payload);
    return r;
  },
};
